export default __webpack_public_path__ + "static/media/Mystic's Bracers of the Purple Sun.8e7fbc02.jpg";